import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  NumberField,
  useTheme,
  usePermissions,
  DateField,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import CustomerListExpandList from "../../components/customerLists/expand/CustomerListExpandList";
import customerListFilterList from "../../components/customerLists/filter/customerListFilterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const CustomerListList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.label.customer"
        empty={false}
        actions={<DownloadAction />}
        filters={customerListFilterList(permissions)}
        queryOptions={{ meta: { sort: ["customers.code ASC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          expand={<CustomerListExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="code" label="mine.label.code" />
          <TextField source="customer_type.code" label="mine.label.type" />
          <TextField source="sales_area.name" label="Area" />
          <TextField source="name" label="mine.label.name" />
          <TextField source="pic" label="PIC" />
          <NumberField source="loan_limit" label="mine.label.loan_limit" />
          <NumberField source="loan_tenor" label="mine.label.loan_tenor" />
          <TextField source="creator_name" label="mine.label.created_by" />
          <DateField
            source="created_at"
            label="mine.label.created_at"
          />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default CustomerListList;
